import type { Permission } from '@customerio/hydra-permissions';

/**
 * Which permission each thing an item can seed asks for, shared by the Use
 * in menu and the item page's empty usage surfaces so the two cannot drift.
 */
export const CREATE_PERMISSION = {
  segment: 'journeys/segments/create',
  campaign: 'journeys/campaigns/create',
  newsletter: 'journeys/newsletters/create',
  snippet: 'journeys/snippets/create',
  layout: 'journeys/layouts/create',
} as const satisfies Record<'segment' | 'campaign' | 'newsletter' | 'snippet' | 'layout', Permission>;
